module.exports = __webpack_public_path__ + "images/emoji/seat.22af9b0360ff4fc17293.png";